import {Link} from 'react-router';
import '../css/footer.css';

export default function Footer() {
    return (
        <footer className="footer">
            {/* ⚠️ The three browse pages moved to the header nav (`Nav.tsx`), where they
                belong. They were here only because `/` is still the previous implementation's
                homepage and its header had no navigation at all — a legal footer was the one
                shared surface that existed. What remains is what a reader actually looks for
                in a footer. */}
            <Link to="/methodik">Wie wir arbeiten</Link>
            <span className="separator">|</span>
            <Link to="/impressum">Impressum</Link>
            <span className="separator">|</span>
            <Link to="/datenschutz">Datenschutz</Link>
        </footer>
    );
}
